import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthApi from "../../api/authApi";
import AuthShell from "./AuthShell";
import { Spinner } from "react-bootstrap";

const EmailVerification = () => {
  let api = new AuthApi();
  let navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState<boolean>(true);

  useEffect(() => {
    const id = searchParams.get("code");
    if (id) {
      handleVerification(id);
    } else {
      navigate("/login");
    }
  }, []);

  const handleVerification = async (code: string) => {
    if (code) {
      await api
        .verifyEmail({ code })
        .then((response: any) => {
          if (response.success) {
            toast.success(response.msg);
            navigate("/verified-thank-You");
          } else {
            toast.error(response.msg);
            navigate("/login");
          }
        })
        .catch((error: any) => {
          console.log(error);
          setVerifying(false);
        });
    }
  };

  return (
    <AuthShell
      title="Email Verification"
      subtitle="Verifying your email address..."
      showBackToLogin
    >
      <div className="text-center py-4">
        {verifying ? (
          <>
            <Spinner animation="border" variant="primary" role="status" className="mb-3">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="text-muted mb-0">
              Please wait while we confirm your email verification link...
            </p>
          </>
        ) : (
          <p className="text-danger mb-0">
            Verification link could not be processed. Please try logging in again.
          </p>
        )}
      </div>
    </AuthShell>
  );
};

export default EmailVerification;

